import {useAppDispatch} from '../../stores/configureStore'
import ControlGroup from './ControlGroup'
import FontOption from './FontOption'
import {handleUpdatedAttributes} from '../../utils/helpers/attributeHelper'
import {ImgCaption} from '../../models/editor/imgCaption'
import {useTranslation} from 'react-i18next'

interface Props {
  img: ImgCaption
}

export default function FontStyleController({img}: Props) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <ControlGroup title={t('Betűtípus')}>
      <>
        <FontOption
          img={img}
          onClick={() =>
            handleUpdatedAttributes(dispatch, img, {bold: !img.bold})
          }
          text={t('Félkövér')}
          fontOption="bold"
        />
        <FontOption
          img={img}
          onClick={() =>
            handleUpdatedAttributes(dispatch, img, {italic: !img.italic})
          }
          text={t('Dőlt')}
          fontOption="italic"
        />
        <FontOption
          img={img}
          onClick={() =>
            handleUpdatedAttributes(dispatch, img, {underline: !img.underline})
          }
          text={t('Aláhúzás')}
          fontOption="underline"
        />
      </>
    </ControlGroup>
  )
}
